// One dynamic import per template skin, in a module small enough for the entry
// chunk to reach for without dragging anything else in.
//
// storefront.jsx used to import all eleven statically. Splitting them means a
// store loads only its own — but it also meant the browser could not DISCOVER
// which one until the storefront chunk had downloaded and the store API had
// answered, two hops deep. prefetchTemplate() closes that gap: the server puts
// the template id in the head (seoBootScript), so the entry chunk can start
// the right download immediately, in parallel with everything else.
export const TPL = {
  8: () => import('./tpl8'),
  9: () => import('./tpl9'),
  10: () => import('./tpl10'),
  11: () => import('./tpl11'),
  12: () => import('./tpl12'),
  13: () => import('./tpl13'),
  14: () => import('./tpl14'),
  15: () => import('./tpl15'),
  16: () => import('./tpl16'),
  17: () => import('./tpl17'),
  18: () => import('./tpl18'),
};

// Pages that live in a module of their own rather than their template's.
const PAGE_CHUNKS = {
  14: {
    'sleep-spray/natural-sleep-spray': () => import('./tpl14Natural.jsx'),
    'sleep-spray/natural-sleep-aid': () => import('./tpl14Natural.jsx'),
    'sleep-spray/sleep-deprivation': () => import('./tpl14Natural.jsx'),
    'sleep-spray/how-to-fix-grogginess': () => import('./tpl14Natural.jsx'),
    'sleep-spray/adaptogens-for-mental-alertness': () => import('./tpl14Natural.jsx'),
    'sleep-spray/stress-relief-spray': () => import('./tpl14Natural.jsx'),
    'sleep-spray/oral-sleep-spray': () => import('./tpl14Natural.jsx'),
    'sleep-spray/vegan-sleep-spray': () => import('./tpl14Natural.jsx'),
    'sleep-spray/pillow-spray-for-sleep': () => import('./tpl14Natural.jsx'),
    'sleep-spray/best-sleep-spray-for-adults': () => import('./tpl14Natural.jsx'),
    'sleep-spray/melatonin-sleep-spray': () => import('./tpl14Natural.jsx'),
  },
};

// Start the downloads this page is certain to need. Failures are swallowed:
// this is a head start, not a dependency — the real import still runs through
// loadChunk, which owns the post-deploy recovery path.
export const prefetchTemplate = (templateId, pathname = '') => {
  const tid = Number(templateId);
  if (!tid || !TPL[tid]) return;
  TPL[tid]().catch(() => {});
  const path = String(pathname || '').replace(/^\/+|\/+$/g, '');
  const page = PAGE_CHUNKS[tid]?.[path];
  if (page) page().catch(() => {});
};

export default TPL;
